/**
 * EmptyState — empty list placeholder with icon, text, and optional CTA action.
 * icon accepts either a ReactNode (element) or a Lucide icon component (type).
 */
import React from 'react';

interface EmptyStateProps {
  icon: React.ReactNode | React.ComponentType<any>;
  iconColor?: string;
  title: string;
  subtitle?: string;
  action?: { label: string; onClick: () => void };
}

export function EmptyState({ icon, iconColor = 'text-gray-400 dark:text-gray-500', title, subtitle, action }: EmptyStateProps) {
  // If icon is a component type, render it as an element
  const iconElement = React.isValidElement(icon)
    ? icon
    : React.createElement(icon as React.ComponentType<any>, { className: `w-12 h-12 ${iconColor}` });

  return (
    <div className="empty-state">
      <div className="empty-state-icon">{iconElement}</div>
      <div className="empty-state-text">{title}</div>
      <div className="empty-state-subtext">{subtitle}</div>
      {action && (
        <button onClick={action.onClick} className="btn btn-primary mt-4">
          {action.label}
        </button>
      )}
    </div>
  );
}
